<template>
  <div class="product-payresult" style="text-align:center;">
    <img
      src="../../../static/images/icon/common_icons_miniprogram@2x.png"
      alt=""
      class="icon-success"
    />
    <div class="xltitle">支付成功</div>
    <div class="desc">本次支付已经成功，您的权益已经生效了</div>
    <button class="btn btn-gohome" @click="gohome">去使用</button>
    <button class="btn btn-gomy" @click="gomy">返回</button>
  </div>
</template>

<script>
import Vue from "vue";
import config from "@/config";
import { mapMutations,mapActions,mapState ,mapGetters } from 'vuex'
export default {
  name: "product-payresult",
  data() {
    return {};
  },
  watch: {},
  methods: {
    ...mapMutations(["set_firm_info"]),
    ...mapActions(["getFirmInfo"]),
    gohome() {
      this.$router.replace({
        path: "/",
        query: {},
      });
    },
    gomy() {
      this.$router.replace({
        path: "/product/index",
        query: {},
      });
    },
  },
  components: {},
  computed: {
  },
  created() {
    this.set_firm_info();
    this.getFirmInfo();
  },
  mounted() {

  },
  updated() {},
};
</script>

<style scoped lang="scss">
@import "../../../static/scss/var";
.product-payresult {
  background-color: #fff;
  padding: vw(146) vw(56);
  box-sizing: border-box;
  .icon-success {
    width: vw(128);
  }
  .xltitle {
    font-size: vw(36);
    color: #333333;
    margin-top: vw(28);
    line-height: vw(50);
    font-weight: 500;
  }
  .desc {
    color: #666666;
    margin-top: vw(40);
    line-height: vw(40);
    font-size: vw(28);
    margin-bottom: vw(96);
  }
  .btn {
    width: 100%;
    height: vw(100);
    border-radius: vw(50);
    border: 0;
    font-size: vw(38);
    cursor: pointer;
  }
  .btn-gohome {
    background-color: #4356d2;
    color: #fff;
  }

  .btn-gomy {
    margin-top: vw(40);
    background-color: #fafafa;
    border: vw(2) solid #d4d4d4;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only <style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>-->
